import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useDeepCompareEffect } from 'react-use';
import { camelCase, sortBy } from 'lodash';
import { useFilterSelector, useTranslate } from '@hooks';
import { fetchEmailTemplates } from '@actions';
import { emailTemplateEmailTypes, emailTemplateSortedTypes } from '@constants';
import { CheckboxButtonGroup, AlertPopover } from '@dotone/react-ui-core';

const emailTemplateSelector = ({ emailTemplateList: { data, ...rest } }) => ({
  ...rest,
  data: sortBy(data || [], (item) => emailTemplateSortedTypes.indexOf(item.emailType)),
});

const EmailTemplateCheckboxGroup = ({ name, formProps, offerId, affiliateId, ...otherProps }) => {
  const { t, locale } = useTranslate('emailTemplate', 'emailTypes');
  const dispatch = useDispatch();
  const { setValue, watch } = formProps;
  const emailTemplateId = watch(name);
  const query = { locale, offerId, affiliateId };
  const { data: emailTemplates } = useFilterSelector(emailTemplateSelector, {
    locale,
    stateKey: [offerId, affiliateId].join('-'),
  });

  const options = emailTemplates.map((emailTemplate) => {
    const key = camelCase(emailTemplate.emailType);
    return {
      value: emailTemplate.id,
      label: (
        <div>
          {t(key)}
          <AlertPopover content={t(`emailTemplate:hints.${key}`)} target={key} />
        </div>
      ),
    };
  });

  useDeepCompareEffect(() => {
    if (!emailTemplates.length) {
      dispatch(fetchEmailTemplates(query));
    }
  }, [dispatch, query, emailTemplates.length]);

  useEffect(() => {
    if (!emailTemplateId && emailTemplates.length) {
      const defaultEmailTemplate = emailTemplates.find(
        (tem) => tem.emailType === emailTemplateEmailTypes.GENERAL_AFFILIATE
      );
      setValue(name, defaultEmailTemplate?.id);
    }
  }, [setValue, name, emailTemplateId, emailTemplates]);

  return (
    <CheckboxButtonGroup
      name={name}
      formProps={formProps}
      options={options}
      cols={4}
      {...otherProps}
    />
  );
};

export default EmailTemplateCheckboxGroup;
